import Vue from 'vue';
import Router from 'vue-router';

// const routerPush = Router.prototype.push;
// Router.prototype.push = function push (location) {
//   return routerPush.call(this, location);
// };

Vue.use(Router);

export default new Router({
  mode: 'hash', // 去掉url中的#
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index')
    },
    // 业务统计
    {
      path: '/censusBusiness',
      name: 'censusBusiness',
      component: () => import('@/views/statistics/business/index'),
      meta: {
        title: ['业务统计']
      }
    },
    // 账户管理
    {
      path: '/accountAdmin',
      name: 'accountAdmin',
      component: () => import('@/views/admin/account/index'),
      meta: {
        title: ['账户管理']
      }
    },
    // 添加账户
    {
      path: '/accountAdmin/addAccount',
      name: 'addAccount',
      component: () => import('@/views/admin/account/addAccount'),
      meta: {
        title: ['账户管理', '添加账户']
      }
    },
    // 编辑账户
    {
      path: '/accountAdmin/editAccount',
      name: 'editAccount',
      component: () => import('@/views/admin/account/addAccount'),
      meta: {
        title: ['账户管理', '编辑账户']
      }
    },
    // 账户详情
    {
      path: '/accountAdmin/manage',
      name: 'manage',
      component: () => import('@/views/admin/account/manage'),
      meta: {
        title: ['账户管理', '账户详情']
      }
    },
    // 添加应用
    // {
    //   path: '/accountAdmin/addApply',
    //   name: 'addApply',
    //   component: () => import('@/views/admin/account/apply/add'),
    //   meta: {
    //     title: ['账户管理', '添加数据模型']
    //   }
    // },
    {
      path: '/accountAdmin/addApply',
      name: 'addApply',
      component: () => import('@/views/admin/account/addDataModel/index'),
      meta: {
        title: ['账户管理', '添加数据模型']
      }
    },
    // 应用详情
    {
      path: '/accountAdmin/applyDetail',
      name: 'applyDetail',
      component: () => import('@/views/admin/account/apply/detail'),
      meta: {
        title: ['账户管理', '数据模型详情']
      }
    },
    // 应用管理
    {
      path: '/digifaxAdmin',
      name: 'digifaxAdmin',
      component: () => import('@/views/admin/digifax/index'),
      meta: {
        title: ['数模管理']
      }
    },
    {
      path: '/digifaxAdmin/detail',
      name: 'digifaxAdminDetail',
      component: () => import('@/views/admin/account/apply/detail'),
      meta: {
        title: ['数模管理', '数模详情']
      }
    },
    // 配置数据字典
    {
      path: '/applyAdmin/configData',
      name: 'configData',
      component: () => import('@/views/admin/digifax/configData'),
      meta: {
        title: ['数模管理', '配置数据字典']
      }
    },
    // 存证管理
    {
      path: '/exEvidenceAdmin',
      name: 'exEvidenceAdmin',
      component: () => import('@/views/admin/exEvidence/index'),
      meta: {
        title: ['存证管理']
      }
    },
    // 存证管理详情
    {
      path: '/exEvidenceAdmin/exEvidencedetail',
      name: 'exEvidencedetail',
      component: () => import('@/views/admin/exEvidence/detail'),
      meta: {
        title: ['存证管理', '存证详情']
      }
    },
    // 费用管理
    {
      path: '/costAdmin',
      name: 'costAdmin',
      component: () => import('@/views/admin/cost/index'),
      meta: {
        title: ['费用管理']
      }
    },
    // 费用管理详情
    {
      path: '/costAdmin/costAdminDetail',
      name: 'costAdminDetail',
      component: () => import('@/views/admin/cost/detail'),
      meta: {
        title: ['费用管理', '费用详情']
      }
    },
    // 数据目录
    {
      path: '/dataCatalog',
      name: 'dataCatalog',
      component: () => import('@/views/admin/dataCatalog/index'),
      meta: {
        title: ['数据目录']
      }
    },
    // 数据交换管理
    {
      path: '/dataExchange',
      name: 'dataExchange',
      component: () => import('@/views/admin/dataExchange/index'),
      meta: {
        title: ['数据交换']
      }
    },
    // 数据交换管理-详情
    {
      path: '/dataExchange/detail',
      name: 'dataExchangeDetail',
      component: () => import('@/views/admin/dataExchange/detail'),
      meta: {
        title: ['数据交换', '详情']
      }
    },
    // 证书管理
    {
      path: '/certificate',
      name: 'certificate',
      component: () => import('@/views/admin/certificate/index'),
      meta: {
        title: ['证书管理']
      }
    },
    // 权限配置
    {
      path: '/jurisdictionInstall',
      name: 'jurisdictionInstall',
      component: () => import('@/views/install/jurisdiction/index'),
      meta: {
        title: ['权限配置']
      }
    },
    // 用户设置
    {
      path: '/userInstall',
      name: 'userInstall',
      component: () => import('@/views/install/user/index'),
      meta: {
        title: ['用户设置']
      }
    },
    // 用户设置-添加角色
    {
      path: '/userInstall/userInstallAdd',
      name: 'userInstallAdd',
      component: () => import('@/views/install/user/add'),
      meta: {
        title: ['用户设置', '添加角色']
      }
    },
    // 用户设置-角色详情
    {
      path: '/userInstall/userDetail',
      name: 'userDetail',
      component: () => import('@/views/install/user/add'),
      meta: {
        title: ['用户设置', '角色详情']
      }
    },
    // 用户设置-角色编辑
    {
      path: '/userInstall/userEdit',
      name: 'userEdit',
      component: () => import('@/views/install/user/add'),
      meta: {
        title: ['用户设置', '角色编辑']
      }
    },
    {
      path: '/applyEmall',
      name: 'applyEmall',
      component: () => import('@/views/admin/dataModelMall/index.vue'),
      meta: {
        title: ['数模商城']
      }
    },
    {
      path: '/dataModelDetail',
      name: 'DataModelDetail',
      component: () => import('@/views/admin/dataModelMall/detail.vue'),
      meta: {
        title: ['数模商城', '详情']
      }
    },
    {
      path: '/orgType',
      name: 'orgType',
      component: () => import('@/views/admin/companyType/index.vue'),
      meta: {
        title: ['企业类型管理']
      }
    },
    {
      path: '/companyTypeMange',
      name: 'CompanyTypeMange',
      component: () => import('@/views/admin/companyType/index.vue'),
      meta: {
        title: ['企业类型管理']
      }
    },
    {
      path: '/addCompanyType',
      name: 'AddCompanyType',
      component: () => import('@/views/admin/companyType/addCompanyType.vue'),
      meta: {
        title: ['企业类型管理', '添加企业类型']
      }
    },
    {
      path: '/editCompanyType',
      name: 'EditCompanyType',
      component: () => import('@/views/admin/companyType/editCompanyType.vue'),
      meta: {
        title: ['企业类型管理', '编辑关联企业']
      }
    },
    // 字典管理
    {
      path: '/dictionaries',
      name: 'dictionaries',
      component: () => import('@/views/admin/dictionaries/index'),
      meta: {
        title: ['字典管理']
      }
    },
    // 在线升级管理
    {
      path: '/upgradeManage',
      name: 'upgradeManage',
      component: () => import('@/views/admin/upgradeManage/index'),
      meta: {
        title: ['在线升级管理']
      }
    },
    // 调用日志
    {
      path: '/callLog',
      name: "callLog",
      component: () => import('@/views/cloudInterface/callLog/index'),
    },
    // 调用日志详情页
    {
      path: '/callLogDetail',
      name: "callLogDetail",
      component: () => import('@/views/cloudInterface/callLog/detailPage'),
    },
    {
      path: '/cloudInterface',
      name: "cloudInterface",
      component: () => import('@/views/cloudInterface/cloudInterface/index_new'),
    },
    {
      path: '/cloudInterfaceDetail',
      name: "cloudInterfaceDetail",
      component: () => import('@/views/cloudInterface/cloudInterface/detailPage'),
    },
    {
      path: '/callStatistics',
      name: 'callStatistics',
      component: () => import("@/views/cloudInterface/callStatistics/index"),
    },
    {
      path: '/screen',
      name: 'screen',
      component: () => import("@/views/screen/index")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js